import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullTeam from "../fragments/Team"

const query = gql`
  query Team($tenantId: String!, $teamId: String!) {
    team(tenantId: $tenantId, id: $teamId) {
      ...fullOldTeam
      branding {
        businessId
        isEnabled
        businessLogoUrl
        primaryColour
        textColour
      }
    }
  }
  ${fullTeam}
`

export const teamKey = getQueryNames(query)[0]

export default query
